import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import classes from "./PlayerPointsModal2.module.css";
import { getPlayerPointsApi } from "../../http/http";
import { togglePlayerPointsModal } from "../../store/slices/playerPointsModalSlice";
import SmallLoader from "../SmallLoader";

const STAT_ROWS = [
    { label: "Minutes Played",          calcKey: "minutes",              pointKey: "minutesPoints" },
    { label: "Player Rating",           calcKey: "rating",               pointKey: "ratingPoints" },
    { label: "Shots on Goal",           calcKey: "shots",                pointKey: "shotsPoints" },
    { label: "Goals",                   calcKey: "goal",                 pointKey: "goalPoints" },
    { label: "Goals Conceded",          calcKey: "goalsConceded",        pointKey: "goalsConcededPoints" },
    { label: "Goal Assists",            calcKey: "goalAssists",          pointKey: "goalAssistsPoints" },
    { label: "Goals Saved",             calcKey: "goalSaves",            pointKey: "goalSavesPoints" },
    { label: "Ball Passes",             calcKey: "passes",               pointKey: "passesPoints" },
    { label: "Fouls",                   calcKey: "fouls",                pointKey: "foulsPoints" },
    { label: "Yellow Cards",            calcKey: "yellowCard",           pointKey: "yellowCardPoints" },
    { label: "Red Cards",               calcKey: "redCard",              pointKey: "redCardPoints" },
    { label: "Tackle Blocks",           calcKey: "tackleBlock",          pointKey: "tackleBlockPoints" },
    { label: "Tackle Interceptions",    calcKey: "tackleInterception",   pointKey: "tackleInterceptionPoints" },
    { label: "Duels",                   calcKey: "duel",                 pointKey: "duelPoints" },
    { label: "Dribbles",                calcKey: "dribble",              pointKey: "dribblePoints" },
];

const PlayerPointsModal2 = ({ matchFixtureId, playerId, playerPointsModal }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [player, setPlayer] = useState({});
    const [points, setPoints] = useState({});
    const [totalPoints, setTotalPoints] = useState({});
    const [calculations, setCalculations] = useState({});

    const { userDetails } = useSelector(state => state?.persisted?.userSlice);
    const dispatch = useDispatch();

    const fetchDataFromBackend = async () => {
        try {
            setLoading(true);
            const response = await getPlayerPointsApi(matchFixtureId, playerId, userDetails?.token);
            if (response?.data?.status == 0) {
                setError(true);
            } else {
                setError(false);
                setPlayer(response?.data?.player);
                setPoints(response?.data?.points);
                setTotalPoints(response?.data?.totalPoints);
                setCalculations(response?.data?.calculations);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error(
                error?.response?.data?.message ||
                error?.data?.message ||
                error?.message ||
                error
            );
        }
    };

    useEffect(() => {
        if (playerPointsModal || playerId) {
            fetchDataFromBackend();
        }
    }, [playerPointsModal, playerId]);

    const handleClose = () => dispatch(togglePlayerPointsModal({ matchFixtureId: null, playerId: null }));

    return (
        <Dialog
            header="Player Overview"
            visible={playerPointsModal}
            position="bottom"
            style={{ width: "100%", maxWidth: "480px", margin: 0 }}
            onHide={handleClose}
        >
            {loading ? (
                <div style={{ padding: "40px", display: "flex", justifyContent: "center" }}>
                    <SmallLoader />
                </div>
            ) : !error ? (
                <div className={classes.container}>
                    {/* Player header */}
                    <div className={classes.panel_header}>
                        <div className={classes.image_container}>
                            <img src={player?.playerPhoto} alt={player?.playerName} className={classes.image} />
                        </div>
                        <span className={classes.text}>{player?.playerName}</span>
                    </div>

                    {/* Stat rows */}
                    <div className={classes.panel_container}>
                        {STAT_ROWS.map(({ label, calcKey, pointKey }) => (
                            <div className={classes.grid} key={pointKey}>
                                <span className={classes.text}>
                                    {label}
                                    {calculations?.[calcKey] !== undefined && (
                                        <> ({calculations[calcKey]})</>
                                    )}
                                </span>
                                <span className={classes.text_right}>{points?.[pointKey] ?? 0}</span>
                            </div>
                        ))}
                    </div>

                    {/* Total points */}
                    <div className={classes.btn_container}>
                        <div className={classes.points_banner}>
                            <p className={classes.points_label}>Total Points</p>
                            <p className={classes.points_value}>{totalPoints?.totalPoints ?? 0}</p>
                        </div>
                    </div>
                </div>
            ) : (
                <div className={classes.message_box}>
                    <p className={classes.message}>Player did not participate in this match.</p>
                </div>
            )}
        </Dialog>
    );
};

export default PlayerPointsModal2;